import { PAGE_ROUTES } from "lib/constants/page-routes";
import { AppContext } from "lib/contexts/app-context";
import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  const { appState } = useContext(AppContext);

  return appState.isUserLoggedIn ? (
    <Outlet />
  ) : (
    <Navigate to={PAGE_ROUTES.AUTHENTICATION.Login} />
  );
};

export default ProtectedRoute;
